import React from "react";
import { API_URL } from "../Utils/Config";
import Loader from "../Utils/Loader";
import { Navigate, useParams } from "react-router-dom";

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class RedirectLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            url: "/",
            query: this.props.params.search_query,
            error: null
        };
    }

    async componentDidMount() {
        try {
            let url = "/";
            console.log(`Processing query: ${this.state.query}`);

            // Check groups first since water-pipe is a group
            const groups_url = `${API_URL}/api/groups/${this.state.query}/`;
            const groups_response = await fetch(groups_url);
            const groups_data = await groups_response.json();
            if (groups_response.ok && groups_data.results && groups_data.results.length >= 1) {
                url = `/database/groups/${this.state.query}`;
                console.log(`Group found, redirecting to: ${url}`);
                this.setState({ loading: false, url });
                return;
            }

            // Check items
            const item_url = `${API_URL}/api/items/exact/${this.state.query}/`;
            let item_data = {};
            try {
                const item_response = await fetch(item_url);
                if (item_response.ok) {
                    item_data = await item_response.json();
                    if (item_data.results && Array.isArray(item_data.results) && item_data.results.length >= 1) {
                        url = `/database/${this.state.query}`;
                        console.log(`Item found, redirecting to: ${url}`);
                        this.setState({ loading: false, url });
                        return;
                    }
                }
            } catch (e) {
                console.warn(`Item fetch failed for ${this.state.query}: ${e.message}`);
            }

            // Check stores
            if (this.state.query.includes("store-")) {
                const shop_url = `${API_URL}/api/shop/${this.state.query.replace("store-", "")}/`;
                const shop_response = await fetch(shop_url);
                const shop_data = await shop_response.json();
                if (shop_response.ok && shop_data.results && shop_data.results.length >= 1) {
                    url = `/guide-book/towns/${shop_data.results[0].town.town_safe_name}/${shop_data.results[0].safe_name}/${shop_data.results[0].id}`;
                    console.log(`Store found, redirecting to: ${url}`);
                    this.setState({ loading: false, url });
                    return;
                }
            }

            // Check towns
            const town_url = `${API_URL}/api/towns/exact/${this.state.query}/`;
            const town_response = await fetch(town_url);
            const town_data = await town_response.json();
            if (town_response.ok && town_data.results && town_data.results.length >= 1) {
                url = `/guide-book/towns/`;
                console.log(`Town found, redirecting to: ${url}`);
                this.setState({ loading: false, url });
                return;
            }

            // Check blogs
            if (this.state.query.includes("blog-")) {
                const blog_url = `${API_URL}/api/blogposts/exact/${this.state.query.replace("blog-", "")}/`;
                const blog_response = await fetch(blog_url);
                const blog_data = await blog_response.json();
                if (blog_response.ok && blog_data.results && blog_data.results.length >= 1) {
                    url = `/blog/${blog_data.results[0].id}`;
                    console.log(`Blog found, redirecting to: ${url}`);
                    this.setState({ loading: false, url });
                    return;
                }
            }

            // Check patches
            if (this.state.query.includes("patch-")) {
                const patch_url = `${API_URL}/api/patchnote/exact/${this.state.query}/`;
                const patch_response = await fetch(patch_url);
                const patch_data = await patch_response.json();
                if (patch_response.ok && patch_data.results && patch_data.results.length >= 1) {
                    url = `/patchnotes/`;
                    console.log(`Patch found, redirecting to: ${url}`);
                    this.setState({ loading: false, url });
                    return;
                }
            }

            // Check digsites
            if (["ember-cradle", "south-hope", "mildews-aquifer", "dreck-quarry", "icehelm", "snowrune-falls", "dawn-rest", "shattered-breach", "cinder-footing", "waterside", "scoria-chamber", "lumberton-bluff"].includes(this.state.query)) {
                url = `/guide-book/digsites/`;
                console.log(`Digsite found, redirecting to: ${url}`);
                this.setState({ loading: false, url });
                return;
            }

            // Fallback if no match
            console.warn(`No match found for query: ${this.state.query}`);
            this.setState({ loading: false, url });

        } catch (error) {
            console.error("RedirectLink error:", error);
            this.setState({
                loading: false,
                error: error.message,
                url: "/"
            });
        }
    }

    render() {
        if (this.state.error) {
            return <div>Error: {this.state.error}</div>;
        }
        return (
            <div className="ui container">
                {this.state.loading ? (
                    <Loader />
                ) : (
                    <Navigate to={this.state.url} />
                )}
            </div>
        );
    }
}

export default withParams(RedirectLink);